import React, { useState, useEffect } from 'react';
import { Slider, withStyles, Grid, withTheme } from '@material-ui/core';
import useDebounce from '../../hooks/useDebounce';
import { formatMoney } from '../../utils';

const SLIDER_SHADOW =
    '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)';
const SLIDER_STYLE = {
    root: {},
    thumb: {
        height: 24,
        width: 24,
        backgroundColor: '#fff',
        boxShadow: SLIDER_SHADOW,
        marginTop: -12,
        marginLeft: -12,
        '&:focus,&:hover,&$active': {
            boxShadow:
                '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)',
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: SLIDER_SHADOW
            }
        },
        border: 'solid 3px'
    },
    active: {},
    valueLabel: {
        left: 'calc(-50% + 11px)',
        top: -22,
        '& *': {
            background: 'transparent',
            color: '#000'
        }
    },
    track: {
        height: 3
    },
    rail: {
        height: 3,
        opacity: 0.5,
        backgroundColor: '#bfbfbf'
    },
    mark: {
        backgroundColor: '#bfbfbf',
        height: 8,
        width: 1,
        marginTop: -3
    },
    markActive: {}
};

const PriceSlider = props => {
    const { value, setValue, theme, label } = props;
    const [price, setPrice] = useState(value);
    useEffect(() => {
        setPrice(value);
    }, [value.join('-'), setPrice]);

    useDebounce(() => setValue(null, price), [price.join('-'), setValue], 500);

    return (
        <Grid item>
            <p>{label}</p>
            <p
                style={{
                    color: theme.palette.primary.main,
                    fontSize: 16,
                    fontWeight: 500
                }}
            >{`${formatMoney(price[0])} - ${formatMoney(price[1])}`}</p>

            <Grid item container justifyContent="center" className="price-slider-wrapper">
                <Slider {...props} value={price} onChange={(ev, newValue) => setPrice(newValue)} />
            </Grid>
        </Grid>
    );
};

export default withTheme(withStyles(SLIDER_STYLE)(PriceSlider));
